import React, {useCallback} from 'react';
// import { Button } from 'semantic-ui-react';
import {Button, Badge,Row, Col} from 'reactstrap';
import screenfull from 'screenfull';
import './Launch.css';
import clientConfig from './client.json';
import buttonImage from '../../static/launch_arrow_sml.png';
import bbLogo from '../../static/lslogo_white.png';
const client: ClientJson = clientConfig as ClientJson;


class ClientJson {
  description?: string = 'description';
  title?: string = 'title';
}

interface LaunchProps {
  Launch: () => void;
}

export const LaunchView: React.FC<LaunchProps> = (props: LaunchProps) => {
  
  const requestFS = async() => {
    console.log('Request FS')
    // await screenfull.request()
    props.Launch()
  }

  const exitFS = async() => {
    console.log('Exiting FS');
    await screenfull.exit();
  }

  return (
    
    <div id="launchContainer">
      <div className="launchCard position-absolute top-50 start-50 translate-middle"
          onClick={requestFS} >
        <Row className="d-flex align-items-center">
          <Col md={9} >
            <img src={bbLogo} alt="LudaSpace Logo" className="launchCardLogo"/>
          </Col>
          <Col md={3} className="d-flex justify-content-end">
            <img src={buttonImage} 
                className="launchButton" 
                alt="Launch Virtual World"  
            /> 
          </Col>
            
        </Row>
      </div>
      <img alt="LudaSpace" src="/ls_logo.svg" style={{ width: 100, position: 'absolute', bottom: 35, right: 40 }} />
    </div>
    
  );
};
